import { createSlice } from '@reduxjs/toolkit';
import { GAMIFIED } from '../../config/constant/projectConstant';
import { removeLocalStorage } from '../../helpers/jsHelper';

export const GAMIFIED_STEPS = {
  LETS_START: 1,
  CHOOSE_ROOM: 2,
  PRODUCT: 3,
  STYLE: 4,
  CAMERA: 5,
  SAVE: 6,
}

export const STAGE = {
  BEGIN: "BEGIN",
  FINAL: "FINAL"
}

const initialState = {
  show: false,
  error: null,
  loading: false,
  step: GAMIFIED_STEPS.LETS_START,
  appFeedback: {
    show: false,
    attempts: null,
    dateOfUserRegister: null,
  },
  finalProgress: false,
  finalProgressStage: STAGE.BEGIN,
  shareImageModal: false,
  highlightProp: null,
};

const gamifyBoarding = createSlice({
  name: 'gamifyBoarding',
  initialState: initialState,
  reducers: {
    resetState: (state) => {
      state.show = true;
      state.step = GAMIFIED_STEPS.LETS_START;
    },
    openGamifiedDialog: (state, { payload }) => {
      state.show = payload;
    },
    closeGamifiedDialog: (state, { payload }) => {
      state.show = false;
      removeLocalStorage(GAMIFIED);
    },
    setGamifiedCurrentStep: (state, { payload }) => {
      state.step = payload;
    },
    setAppFeedbackData: (state, { payload }) => {
      state.appFeedback = {...state.appFeedback, ...payload};
    },
    showAppFeedback: (state) => {
      state.appFeedback.show = true;
    },
    closeAppFeedback: (state) => {
      state.appFeedback.show = false;
    },
    setFinalProgress: (state, { payload }) => {
      state.finalProgress = payload;
    },
    setFinalProgressStage: (state, { payload }) => {
      state.finalProgressStage = payload;
    },
    openShareImageModal: (state) => {
      state.shareImageModal = true;
    },
    closeShareImageModal: (state) => {
      state.shareImageModal = false;
    },
    setHighlightProp: (state, { payload }) => {
      state.highlightProp = payload;
    }
  },
});

export const gamifyBoardingActions = gamifyBoarding.actions;
export const gamifyBoardingSelector = (state) => state.gamifyBoarding;
export const gamifyBoardingReducer = gamifyBoarding.reducer;
export default gamifyBoardingReducer;

export const selectIsGamifiedDialogOpen = (state) => state.gamifyBoarding.show;

export const selectGamifiedCurrentStep = (state) => state.gamifyBoarding.step;

export const selectAppFeedbackEnabled = (state) => state.gamifyBoarding.appFeedback?.show;
export const selectAppFeedbackAttempts = (state) => state.gamifyBoarding.appFeedback?.attempts;

export const selectIsFinalProgress = (state) => state.gamifyBoarding.finalProgress;
export const selectFinalProgressStage = (state) => state.gamifyBoarding.finalProgressStage;

export const selectShareImageModal = (state) => state.gamifyBoarding.shareImageModal;

export const selectHighlightProp = (state) => state.gamifyBoarding.highlightProp;